export enum LocalStorageKeys {
  OptimizationRecommendations = 'optimizationRecommendations',
  SearchHistoryList = 'searchHistoryList',
  InformHeatingCircuitIsIgnored = 'informHeatingCircuitIsIgnored',
  InformOperatingModeIsIgnored = 'informOperatingModeIsIgnored',
  LearningRoomBanner = 'learningRoomBanner',
  isDemoModeRunning = 'isDemoModeRunning',
  // the isViGuideMonitoring flag is set by the ViGuide Mobile app while on the monitoring tab to hide the logout button on our side
  // this flag is read-only, setting and deleting it is on ViGuide Mobile's side
  // https://jira.viessmann-climatesolutions.com/browse/VIG-11615
  isViGuideMonitoring = 'isViGuideMonitoring',
}
